// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".receipt-table[data-v-09470472] .el-drawer__header{margin-bottom:0}.receipt-table[data-v-09470472] .el-drawer__body{padding-top:0}.receipt-table[data-v-09470472] .avue-crud__left{-webkit-box-flex:1;-ms-flex:1;flex:1}", ""]);
// Exports
module.exports = exports;
